export const INNER_DATE_FORMAT = 'YYYY-MM-DD';

export const DISCOUNT_TYPE_PERCENTAGE = 'percentage';
export const DISCOUNT_TYPE_FIXED = 'fixed_amount';